<template>
  <div>
    <c-eth-gas-option
      type="stake"
      :gasLimit="gasLimit"
      @update="updateGasPrices"
    >
      <div class="d-flex mt-10">
        <div>
          <div class="text-5 font-weight-medium">Spend Limit</div>
          <div class="d-flex align-center mt-2 text-2">
            <span class="primary--text">{{ spendLimit }}</span>
            <span class="gray--text text-uppercase ml-1">{{
              currentProject.staking.token
            }}</span>
          </div>
        </div>
        <div class="ml-10">
          <div class="text-5 font-weight-medium ml-10">Transaction Fee</div>
          <div class="d-flex align-center mt-2 text-2">
            <v-divider vertical class="mr-10 border-vault"></v-divider>
            <div>
              <span class="primary--text">{{
                txFees.amount | denomFormat
              }}</span>
              <span class="gray--text text-uppercase ml-1">ETH</span>
            </div>
          </div>
          <div class="mt-2 gray--text text-5 ml-10">
            ${{ txFees.value | currency }}
          </div>
        </div>
      </div>
      <v-divider class="mt-10 mb-10 border-vault"></v-divider>
    </c-eth-gas-option>
    <div class="mt-16">
      <!-- <v-checkbox
        v-model="infiniteCheck"
        label="Approve infinite access"
        class="mr-5"
      ></v-checkbox> -->
      <c-btn
        class="width-100"
        @click="approve"
        :disabled="Number(rawTx.gas || 0) <= 0"
        >Approve</c-btn
      >
    </div>
    <tx-ethereum
      v-if="shouldShowApproveModal"
      title="Approve Spend Limit"
      name="approve"
      :walletAccount="walletAccount"
      :broadcastAction="broadcastAction"
      :txObject="txObject"
      :txFees="txFees"
      :quiet="true"
      @cancel="shouldShowApproveModal = false"
      @onSuccess="onApproveSuccess"
    >
      <div class="d-flex mt-3">
        <div
          class="flex-2 text-left text-5 font-weight-medium text-uppercase gray--text"
        >
          Spend Limit:
        </div>
        <div class="flex-3 text-3">
          {{ spendLimit }} {{ currentProject.staking.token | uppercase }}
        </div>
      </div>
    </tx-ethereum>
  </div>
</template>

<script>
import BN from "bignumber.js";
import { ethers } from "ethers";
import { mapGetters } from "vuex";
import { sleep, fetchEthereumTxStatus } from "@/common/lib/utils";

export default {
  props: {
    txPayload: Object,
    walletAccount: Object,
    getRawTx: Function,
    broadcastAction: String,
  },
  data: () => ({
    infiniteCheck: true,
    gasPrices: {},
    gasLimit: 0,
    rawTx: {},
    shouldShowApproveModal: false,
  }),
  computed: {
    ...mapGetters({
      getTokenPriceInUsd: "appConfig/getTokenPriceInUsd",
      currentProject: "projectConfig/latestProject",
      isTxConfirmed: "notification/isTxConfirmed",
    }),
    spendLimit() {
      return this.infiniteCheck
        ? Number(
            ethers.constants.MaxUint256.div(
              ethers.constants.WeiPerEther
            ).toString()
          ).toExponential(6)
        : this.txPayload.amount;
    },
    txFees() {
      const amount = new BN(this.gasPrices.gas || 0)
        .multipliedBy(this.gasPrices.maxFeePerGas || 0)
        .dividedBy(1e18)
        .toNumber();
      return {
        amount,
        value: amount * this.getTokenPriceInUsd("eth"),
      };
    },
    txObject() {
      return {
        ...this.rawTx,
        ...this.gasPrices,
      };
    },
  },
  methods: {
    updateGasPrices(prices) {
      this.gasPrices = prices;
    },
    async getTxObject() {
      const rawTx = await this.getRawTx();
      this.gasLimit = rawTx.gas;
      this.rawTx = rawTx;
    },
    approve() {
      this.shouldShowApproveModal = true;
    },
    async onApproveSuccess(txHash) {
      const { confirmed, failed } = await Promise.race([
        this.checkTxStatus(txHash),
        this.checkTxStatusEtherscan(txHash),
      ]);
      if (confirmed) {
        this.shouldShowApproveModal = false;
        this.$emit("next");
      } else if (failed) {
        this.$store.dispatch("addAlert", {
          type: "error",
          title: "Approve access failed",
          message:
            "Something went wrong. Please refresh the page and try again.",
        });
      }
    },
    async checkTxStatusEtherscan(txHash, retries = 0) {
      console.log('Checking', retries, txHash);
      if (!this.shouldShowApproveModal) {
        return;
      }
      const result = await fetchEthereumTxStatus(txHash);
      console.log('Result', result);
      if (!result.pending) {
        return result;
      }
      if (retries >= 20) {
        return {
          failed: true,
        };
      }
      await sleep(6000);
      return this.checkTxStatusEtherscan(txHash, retries + 1);
    },
    async checkTxStatus(txHash, retries = 0) {
      console.log('CheckingTxStatus', retries, txHash);
      if (!this.shouldShowApproveModal) {
        return;
      }
      if (this.isTxConfirmed(txHash)) {
        return {
          confirmed: true,
        };
      }
      if (retries >= 120) {
        return {
          failed: true,
        };
      }
      await sleep(1000);
      return this.checkTxStatus(txHash, retries + 1);
    },
  },
  mounted() {
    this.getTxObject();
  },
  watch: {
    infiniteCheck() {
      this.gasLimit = 0;
      this.rawTx = {};
      this.getTxObject();
    },
  },
};
</script>
